import React from 'react';

const ButtonWithIndicator = ({ colorClass, borderClass, className, text, icon, loading, onClick, disabled, dataTestId }) => {
  return (
    <div
      className={`builder-flex builder-items-center builder-px-4 builder-py-2 ${colorClass} ${borderClass} ${disabled ? 'builder-opacity-25' : 'builder-cursor-pointer builder-opacity-100'} ${className}`}
      onClick={disabled ? undefined : onClick}
      data-testid={dataTestId}
    >
      {loading && (
        <div className={`lds-ring mr-2 ${colorClass !== 'builder-bg-white' ? 'lds-ring-white' : 'lds-ring-black'}`} style={{ width: 14, borderColor: 'white' }}>
          <div></div>
        </div>
      )}

      {!loading && icon && <i className={`${icon} ${text ? 'builder-mr-2' : ''}`} />}

      {text}
    </div>
  );
};

ButtonWithIndicator.defaultProps = {
  colorClass: 'builder-bg-white',
  borderClass: 'builder-border builder-border-gray-300',
  disabled: false,
  className: 'builder-ml-2'
};

export default ButtonWithIndicator;
